import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import AppShell from './components/layout/AppShell'
import CookieConsent from './components/CookieConsent'
import HomePage from './pages'
import ManualPage from './pages/ManualPage'
import SimpleManualPage from './pages/SimpleManualPage'
import PythonTestPage from './pages/PythonTestPage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import PortfolioManagementModernPortfolioTheory from './standalone-modules/PortfolioManagementModernPortfolioTheory'
import PortfolioManagementModernPortfolioTheoryFull from './standalone-modules/PortfolioManagementModernPortfolioTheoryFull'
import { usePythonGreenTheme } from './hooks/usePythonTerminalTheme'
import PublisherReadyManuals from './pages/PublisherReadyManuals'
import ModernPortfolioTheoryAcademic from './standalone-modules/ModernPortfolioTheoryAcademic'
import SeriesPage from './pages/SeriesPage'
import MyLibrary from './pages/MyLibrary'
import SubscribePage from './pages/SubscribePage'
import RefundPolicy from './pages/RefundPolicy'
import FairUsePolicy from './pages/FairUsePolicy'
import SubscriptionTerms from './pages/SubscriptionTerms'
import PasswordReset from './pages/PasswordReset'
import CitationLanding from './pages/CitationLanding'
function App() {
  console.log('🚀 App component loaded');

  // Apply green-on-black theme to all Python code blocks
  usePythonGreenTheme();

  return (
    <HelmetProvider>
    <Router>
      <CookieConsent />
      <AppShell>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Direct static routes for key manuals */}
          <Route path="/modern-portfolio-theory" element={<ManualPage />} />
          <Route path="/factor-investing" element={<ManualPage />} />
          <Route path="/credit-default-swaps" element={<ManualPage />} />
          <Route path="/machine-learning-finance" element={<ManualPage />} />
          <Route path="/operational-risk" element={<ManualPage />} />
          <Route path="/market-risk-fundamentals" element={<ManualPage />} />

          {/* Series routes */}
          <Route path="/series/:seriesSlug" element={<SeriesPage />} />
          
          {/* My Library — subscription, full-library purchase, and legacy access */}
          <Route path="/my-library" element={<MyLibrary />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />

          {/* Treasury citation pages — static segments so they are not treated as manuals */}
          <Route path="/treasury-risk-learning-infrastructure" element={<CitationLanding slug="treasury-risk-learning-infrastructure" />} />
          <Route path="/trusted-treasury-voices" element={<CitationLanding slug="trusted-treasury-voices" />} />
          <Route path="/vendor-evaluation-checklist" element={<CitationLanding slug="vendor-evaluation-checklist" />} />
          <Route path="/problems-solved" element={<CitationLanding slug="problems-solved" />} />

          {/* Legal pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/fair-use" element={<FairUsePolicy />} />
          <Route path="/subscription-terms" element={<SubscriptionTerms />} />

          {/* Password reset */}
          <Route path="/reset-password" element={<PasswordReset />} />

          {/* Manuals route - redirects to series/all */}
          <Route path="/manuals" element={<Navigate to="/series/all" replace />} />

          {/* Manuals with slug - redirects to root slug */}
          <Route path="/manuals/:manualSlug" element={<Navigate to="/:manualSlug" replace />} />

          {/* Module by series + slug (e.g. /commodities-energy/why-commodity-energy-matter) */}
          <Route path="/:seriesSlug/:manualSlug" element={<ManualPage />} />
          {/* Dynamic manual route for any manual slug (e.g. /why-commodity-energy-matter) */}
          <Route path=":manualSlug" element={<ManualPage />} />
          
          {/* Test routes */}
          <Route path="/simple-manual" element={<SimpleManualPage />} />
          <Route path="/python-test" element={<PythonTestPage />} />
          <Route path="/module/modern-portfolio-theory" element={<PortfolioManagementModernPortfolioTheory />} />
          <Route path="/module/modern-portfolio-theory-full" element={<PortfolioManagementModernPortfolioTheoryFull />} />
          <Route path="/publisher-ready" element={<PublisherReadyManuals />} />
          <Route path="/academic/modern-portfolio-theory" element={<ModernPortfolioTheoryAcademic />} />
          
          {/* Catch-all route */}
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                  Manual Not Found
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  Current path: {window.location.pathname}
                </p>
                <a href="/" className="bg-primary-600 text-white px-4 py-2 rounded">
                  Go Home
                </a>
              </div>
            </div>
          } />
        </Routes>
      </AppShell>
    </Router>
    </HelmetProvider>
  )
}

export default App
